// extracted by mini-css-extract-plugin
export default {"optionUser":"Dashboard_optionUser__TByfc","active":"Dashboard_active__WS7sH"};